/**
 * Extrai os estilos codificados (metadata) e o texto original do conteúdo de um post.
 * @param content O conteúdo bruto vindo do banco (pode conter <!--style:...-->)
 */
export const extractPostStyle = (content: string) => {
    if (!content) return { style: { bg: '#1a0533', tpl: 'minimalista', paths: [] }, text: '' };
    
    const match = content.match(/^<!--style:({.*?})-->(.*)$/s);
    if (match) {
        try {
            const style = JSON.parse(match[1]);
            return { style, text: match[2] };
        } catch (e) {
            console.warn("[PostUtils] Falha ao parsear metadata de estilo", e);
        }
    }
    
    // Fallback para posts sem metadata ou erro no parse
    return { 
        style: { 
            bg: '#1a0533', 
            tpl: 'minimalista', 
            paths: [],
            align: 'center',
            fId: 'inter',
            fsId: 'medium',
            b: false,
            i: true,
            u: false,
            imgs: {},
            tfms: {}
        }, 
        text: content 
    };
};
